import { render, staticRenderFns } from "./DeclareIndex.vue?vue&type=template&id=60b1f558&scoped=true"
import script from "./DeclareIndex.vue?vue&type=script&lang=js"
export * from "./DeclareIndex.vue?vue&type=script&lang=js"
import style0 from "./DeclareIndex.vue?vue&type=style&index=0&id=60b1f558&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1f558",
  null
  
)

export default component.exports